import { useTranslation } from 'react-i18next';

import type { PlatformUserRole } from '@nucleus-commerce/api-client/platform';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONES: Record<PlatformUserRole, string> = {
  owner: 'border-primary/40 text-primary',
  admin: 'border-info/40 text-info',
  support: 'text-foreground',
  read_only: 'text-muted-foreground',
};

export function UserRoleBadge({ role, className }: { role: PlatformUserRole; className?: string }) {
  const { t } = useTranslation('common');
  return (
    <Badge
      variant="outline"
      data-role={role}
      className={cn('font-medium capitalize', TONES[role], className)}
    >
      {t(`roles.${role}`)}
    </Badge>
  );
}
